import { getPathString } from '@helpers'
import { TIME_LINE_MODE } from '@constants'
import { TimeLineDTOType } from '@types'

export const getKeyFieldY = (config: TimeLineDTOType): string =>
  getPathString(
    config.mode === TIME_LINE_MODE.OBJECT && config.objectX.fieldFromObjectYToLink?.length
      ? config.objectX.fieldFromObjectYToLink
      : config.objectY.keyField
  )
